// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--36KWw";
export var page = "Layout-module--page--NBJGt";
export var background = "Layout-module--background--BbCD2";